// ═══════════════════════════════════════════════════════════════════════════════
// eoh-pm.js — PM Mode Frontend
// ═══════════════════════════════════════════════════════════════════════════════
'use strict';

var API = window.EOH_API || 'https://erp-ai-backend.vercel.app';
var _token   = '';
var _project = null;   // current project object
var _projects = [];    // all user projects
var _members  = [];    // current project members
var _tasks    = [];    // current project tasks
var _currentDocId = null;
var _editingTaskId = null;
var _editingMemberId = null;
var _editingMeetingId = null;
var _taskViewMode = 'board'; // board | list

// ═══════════════════════════════════════════════════════════════════════════════
// INIT
// ═══════════════════════════════════════════════════════════════════════════════
document.addEventListener('DOMContentLoaded', function() {
  _token = localStorage.getItem('eoh_t') || localStorage.getItem('eoh_token') || '';
  if (!_token) {
    showGate('Please log in to access PM Mode. <a href="/pages/erp-chat" style="color:var(--gl)">Go to chat →</a>');
    return;
  }
  initPM();
});

async function initPM() {
  try {
    // Verify PM access
    var r = await apiGet('/pm/summary');
    if (r.error === 'pm_not_included') {
      showGate('Your current plan does not include PM Mode. Please upgrade to access PM features.');
      return;
    }
    if (r.error === 'Unauthorized' || r.error === 'Invalid token') {
      showGate('Please log in to access PM Mode. <a href="/pages/erp-chat" style="color:var(--gl)">Go to chat →</a>');
      return;
    }

    _projects = r.projects || [];
    hide('pm-loading-screen');
    show('pm-app');

    renderProjectSelector();

    // Auto-select last used project
    var lastId = localStorage.getItem('pm_last_project');
    if (lastId && _projects.find(function(p){ return p.id === lastId; })) {
      document.getElementById('pm-project-select').value = lastId;
      await selectProject(lastId);
    } else if (_projects.length === 1) {
      document.getElementById('pm-project-select').value = _projects[0].id;
      await selectProject(_projects[0].id);
    } else {
      showOverviewEmpty();
    }
  } catch(e) {
    hide('pm-loading-screen');
    show('pm-app');
    showOverviewEmpty();
  }
}

function showGate(msg) {
  hide('pm-loading-screen');
  var gate = document.getElementById('pm-gate');
  if (gate) {
    gate.style.display = 'flex';
    if (msg) { var p = gate.querySelector('p'); if (p) p.innerHTML = msg; }
  }
}

// ═══════════════════════════════════════════════════════════════════════════════
// API HELPERS
// ═══════════════════════════════════════════════════════════════════════════════
async function apiGet(path) {
  var r = await fetch(API + path, { headers: { Authorization: 'Bearer ' + _token } });
  return r.json();
}
async function apiPost(path, body) {
  var r = await fetch(API + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + _token }, body: JSON.stringify(body) });
  return r.json();
}
async function apiPut(path, body) {
  var r = await fetch(API + path, { method: 'PUT', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + _token }, body: JSON.stringify(body) });
  return r.json();
}
async function apiDelete(path) {
  var r = await fetch(API + path, { method: 'DELETE', headers: { Authorization: 'Bearer ' + _token } });
  var data = null;
  try { data = await r.json(); } catch (_) { data = null; }   // DELETE may return 204/empty
  if (!r.ok) return { error: (data && data.error) || ('Delete failed (' + r.status + ')') };
  return data || { ok: true };
}

// ═══════════════════════════════════════════════════════════════════════════════
// PROJECT SELECTOR
// ═══════════════════════════════════════════════════════════════════════════════
function renderProjectSelector() {
  var sel = document.getElementById('pm-project-select');
  if (!sel) return;
  sel.innerHTML = '<option value="">-- Select Project --</option>';
  _projects.forEach(function(p) {
    var opt = document.createElement('option');
    opt.value = p.id; opt.textContent = p.name + ' (' + (p.status||'').replace('_',' ') + ')';
    sel.appendChild(opt);
  });
}

async function selectProject(id) {
  if (!id) { _project = null; showOverviewEmpty(); return; }
  localStorage.setItem('pm_last_project', id);
  try {
    var d = await apiGet('/pm/projects/' + id);
    if (d.error) { alert(d.error); return; }
    _project = d.project;
    _members = d.members || [];
    setHeader(_project.name, (_project.erp_system||'') + ' · ' + (_project.status||'').replace('_',' '));
    await loadOverview();
    showPage('overview');
  } catch(e) { console.error(e); }
}

function setHeader(title, sub) {
  var t = document.getElementById('pm-header-title');
  var s = document.getElementById('pm-header-sub');
  if (t) t.textContent = title || 'PM Mode';
  if (s) s.textContent = sub  || '';
}

function showOverviewEmpty() {
  document.getElementById('overview-no-project').style.display = 'flex';
  document.getElementById('overview-content').style.display = 'none';
  setHeader('PM Mode', 'Select or create a project to get started');
}

// ═══════════════════════════════════════════════════════════════════════════════
// NAVIGATION
// ═══════════════════════════════════════════════════════════════════════════════
function showPage(name) {
  if (!_project && name !== 'overview') { alert('Please select a project first.'); return; }
  document.querySelectorAll('.pm-page').forEach(function(p){ p.classList.remove('active'); });
  document.querySelectorAll('.pm-nav-item').forEach(function(n){ n.classList.remove('active'); });
  var page = document.getElementById('page-' + name);
  var nav  = document.getElementById('nav-' + name);
  if (page) page.classList.add('active');
  if (nav)  nav.classList.add('active');

  if (name === 'overview')   loadOverview();
  if (name === 'project')    fillProjectForm();
  if (name === 'tasks')      loadTasks();
  if (name === 'meetings')   loadMeetings();
  if (name === 'documents')  loadDocuments();
  if (name === 'email')      loadEmailLog();
  if (name === 'analysis')      document.getElementById('analysis-result').style.display = 'none';
  if (name === 'emailsettings') loadEmailSettings();
}

// ═══════════════════════════════════════════════════════════════════════════════
// OVERVIEW
// ═══════════════════════════════════════════════════════════════════════════════
async function loadOverview() {
  if (!_project) { showOverviewEmpty(); return; }
  document.getElementById('overview-no-project').style.display = 'none';
  document.getElementById('overview-content').style.display = 'block';

  var [tasksRes, meetingsRes] = await Promise.all([
    apiGet('/pm/projects/' + _project.id + '/tasks'),
    apiGet('/pm/projects/' + _project.id + '/meetings'),
  ]);
  _tasks = tasksRes.tasks || [];
  var meetings = meetingsRes.meetings || [];
  var today = new Date().toISOString().slice(0,10);

  // Stats
  var done = _tasks.filter(function(t){ return t.status === 'done'; }).length;
  var overdue = _tasks.filter(function(t){ return t.due_date && t.due_date < today && !['done','cancelled'].includes(t.status); });
  var upcoming = meetings.filter(function(m){ return m.meeting_date >= today && m.status === 'scheduled'; });

  document.getElementById('overview-stats').innerHTML = [
    { label:'Tasks', value: _tasks.length, color:'var(--gl)' },
    { label:'Done', value: done, color:'#60a5fa' },
    { label:'Overdue', value: overdue.length, color: overdue.length ? 'var(--red)' : 'var(--dim)' },
    { label:'Meetings', value: upcoming.length, color:'var(--gold)' },
  ].map(function(s){
    return '<div class="pm-stat"><div class="pm-stat-val" style="color:' + s.color + '">' + s.value + '</div><div class="pm-stat-lbl">' + s.label + '</div></div>';
  }).join('');

  // Overdue tasks
  var overdueEl = document.getElementById('overview-overdue');
  if (!overdue.length) {
    overdueEl.innerHTML = '<div style="color:var(--gl);font-size:13px;padding:8px 0">✅ No overdue tasks</div>';
  } else {
    overdueEl.innerHTML = overdue.slice(0,5).map(function(t){
      return '<div style="display:flex;align-items:center;justify-content:space-between;padding:8px 0;border-bottom:1px solid var(--border2)">'
        + '<div><div style="font-size:13px;font-weight:600;color:var(--text)">' + t.title + '</div>'
        + '<div style="font-size:11px;color:var(--red)">Due: ' + t.due_date + '</div></div>'
        + '<span class="badge badge-' + t.priority + '">' + t.priority + '</span></div>';
    }).join('');
  }

  // Upcoming meetings
  var meetEl = document.getElementById('overview-meetings');
  if (!upcoming.length) {
    meetEl.innerHTML = '<div style="color:var(--dim);font-size:13px;padding:8px 0">No upcoming meetings</div>';
  } else {
    meetEl.innerHTML = upcoming.slice(0,3).map(function(m){
      var d = new Date(m.meeting_date);
      return '<div style="display:flex;align-items:center;gap:12px;padding:8px 0;border-bottom:1px solid var(--border2)">'
        + '<div style="text-align:center;min-width:40px"><div style="font-size:18px;font-weight:700;color:var(--gl)">' + d.getDate() + '</div>'
        + '<div style="font-size:10px;color:var(--dim)">' + d.toLocaleString('default',{month:'short'}) + '</div></div>'
        + '<div><div style="font-size:13px;font-weight:600;color:var(--text)">' + m.title + '</div>'
        + '<div style="font-size:11px;color:var(--dim)">' + (m.start_time||'') + (m.location?' · '+m.location:'') + '</div></div></div>';
    }).join('');
  }

  // Team
  var teamEl = document.getElementById('overview-team');
  if (!_members.length) {
    teamEl.innerHTML = '<div style="color:var(--dim);font-size:13px">No team members yet. <button onclick="showPage(\'project\')" style="background:none;border:none;color:var(--gl);cursor:pointer;font-size:13px">Add members →</button></div>';
  } else {
    teamEl.innerHTML = '<div style="display:flex;flex-wrap:wrap;gap:10px">' + _members.map(function(m){
      return '<div style="display:flex;align-items:center;gap:8px;padding:8px 12px;background:var(--bg3);border:1px solid var(--border);border-radius:8px">'
        + '<div style="width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,var(--gl),var(--gl2));display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;color:white">' + (m.full_name||'?')[0].toUpperCase() + '</div>'
        + '<div><div style="font-size:13px;font-weight:600;color:var(--text)">' + m.full_name + '</div><div style="font-size:11px;color:var(--dim)">' + (m.title||m.role) + '</div></div></div>';
    }).join('') + '</div>';
  }

  // Update badge
  if (overdue.length) {
    var badge = document.getElementById('nav-tasks-badge');
    if (badge) { badge.textContent = overdue.length; badge.style.display = 'block'; }
  }
}

// ═══════════════════════════════════════════════════════════════════════════════
// PROJECT FORM
// ═══════════════════════════════════════════════════════════════════════════════
function fillProjectForm() {
  if (!_project) return;
  var p = _project;
  setField('proj-name', p.name);
  setField('proj-status', p.status);
  setField('proj-erp', p.erp_system);
  setField('proj-methodology', p.methodology);
  setField('proj-currency', p.currency || 'USD');
  setField('proj-budget', p.budget || '');
  setField('proj-start', p.start_date || '');
  setField('proj-end', p.end_date || '');
  setField('proj-golive', p.go_live_date || '');
  setField('proj-timezone', p.timezone || '');
  setField('proj-description', p.description || '');
  setField('proj-notes', p.notes || '');
  setField('proj-client', p.client_name || '');
  setField('proj-industry', p.client_industry || '');
  setField('proj-phone', p.company_phone || '');
  setField('proj-mobile', p.company_mobile || '');
  setField('proj-linkedin', p.company_linkedin || '');
  setField('proj-website', p.company_website || '');
  setField('proj-logo', p.company_logo || '');
  setField('proj-city', p.city || '');
  setField('proj-country', p.country || '');

  // Modules tags
  renderTagsFromValue('proj-modules-tags', 'proj-modules', p.erp_modules || []);
  // Phases
  renderPhases(p.phases || []);
  // Members
  renderMembersList();
}

async function saveProject() {
  if (!_project) return;
  var res_el = document.getElementById('project-save-result');
  if (res_el) { res_el.style.color = 'var(--dim)'; res_el.textContent = 'Saving...'; }

  var modulesVal = document.getElementById('proj-modules').value;
  var modules = modulesVal ? modulesVal.split(',').map(function(s){ return s.trim(); }).filter(Boolean) : [];
  var phases = collectPhases();

  var updates = {
    name:             getField('proj-name'),
    status:           getField('proj-status'),
    erp_system:       getField('proj-erp'),
    methodology:      getField('proj-methodology'),
    currency:         getField('proj-currency'),
    budget:           parseFloat(getField('proj-budget')) || null,
    start_date:       getField('proj-start') || null,
    end_date:         getField('proj-end')   || null,
    go_live_date:     getField('proj-golive') || null,
    timezone:         getField('proj-timezone'),
    description:      getField('proj-description'),
    notes:            getField('proj-notes'),
    client_name:      getField('proj-client'),
    client_industry:  getField('proj-industry'),
    company_phone:    getField('proj-phone'),
    company_mobile:   getField('proj-mobile'),
    company_linkedin: getField('proj-linkedin'),
    company_website:  getField('proj-website'),
    company_logo:     getField('proj-logo'),
    city:             getField('proj-city'),
    country:          getField('proj-country'),
    erp_modules:      modules,
    phases:           phases,
  };

  try {
    var d = await apiPut('/pm/projects/' + _project.id, updates);
    if (d.project) {
      _project = d.project;
      // Update selector
      var idx = _projects.findIndex(function(p){ return p.id === _project.id; });
      if (idx >= 0) _projects[idx] = _project;
      renderProjectSelector();
      document.getElementById('pm-project-select').value = _project.id;
      setHeader(_project.name, (_project.erp_system||'') + ' · ' + (_project.status||'').replace('_',' '));
      if (res_el) { res_el.style.color = 'var(--gl)'; res_el.textContent = '✅ Saved!'; setTimeout(function(){ res_el.textContent=''; }, 3000); }
    } else {
      if (res_el) { res_el.style.color = 'var(--red)'; res_el.textContent = 'Error: ' + (d.error||'failed'); }
    }
  } catch(e) {
    if (res_el) { res_el.style.color = 'var(--red)'; res_el.textContent = 'Error: ' + e.message; }
  }
}

// ── Phases ──
function renderPhases(phases) {
  var c = document.getElementById('phases-container');
  if (!c) return;
  c.innerHTML = '';
  (phases || []).forEach(function(ph, i) {
    c.appendChild(buildPhaseRow(ph, i));
  });
}
function buildPhaseRow(ph, i) {
  var row = document.createElement('div');
  row.className = 'phase-row'; row.dataset.idx = i;
  row.innerHTML = '<input class="form-input phase-name" placeholder="Phase name" value="' + (ph.name||'') + '">'
    + '<input class="form-input phase-start" type="date" value="' + (ph.start_date||'') + '">'
    + '<input class="form-input phase-end"   type="date" value="' + (ph.end_date||'') + '">'
    + '<button class="btn-icon" onclick="removePhase(this)" title="Remove">✕</button>';
  return row;
}
function addPhase() {
  var c = document.getElementById('phases-container');
  var idx = c.children.length;
  c.appendChild(buildPhaseRow({ name:'', start_date:'', end_date:'' }, idx));
}
function removePhase(btn) { btn.closest('.phase-row').remove(); }
function collectPhases() {
  var rows = document.querySelectorAll('#phases-container .phase-row');
  var phases = [];
  rows.forEach(function(r) {
    var name  = r.querySelector('.phase-name').value.trim();
    var start = r.querySelector('.phase-start').value;
    var end   = r.querySelector('.phase-end').value;
    if (name) phases.push({ name, start_date: start||null, end_date: end||null });
  });
  return phases;
}

// ─ Members list ─
function renderMembersList() {
  var el = document.getElementById('members-list');
  if (!el) return;
  if (!_members.length) {
    el.innerHTML = '<div class="pm-empty"><div class="pm-empty-icon">👤</div><h3>No team members yet</h3></div>';
    return;
  }
  el.innerHTML = _members.map(function(m) {
    var mods = (m.erp_modules||[]).map(function(mod){ return '<span class="member-module">' + mod + '</span>'; }).join('');
    return '<div class="member-card">'
      + '<div class="member-avatar">' + (m.full_name||'?')[0].toUpperCase() + '</div>'
      + '<div class="member-info"><div class="member-name">' + m.full_name + ' <span style="font-size:11px;color:var(--dim);font-weight:400">(' + m.role + ')</span></div>'
      + '<div class="member-meta">' + (m.title||'') + (m.email ? ' · ' + m.email : '') + (m.phone ? ' · ' + m.phone : '') + '</div>'
      + (mods ? '<div class="member-modules">' + mods + '</div>' : '')
      + (m.note ? '<div style="font-size:11px;color:var(--dim);margin-top:4px">' + m.note + '</div>' : '') + '</div>'
      + '<div style="display:flex;gap:6px">'
      + '<button class="btn-icon btn-sm" onclick="editMember(\'' + m.id + '\')">✏️</button>'
      + '<button class="btn-icon btn-sm" onclick="deleteMember(\'' + m.id + '\',\'' + m.full_name.replace(/'/g,'') + '\')">🗑️</button>'
      + '</div></div>';
  }).join('');
}

// ═══════════════════════════════════════════════════════════════════════════════
// NEW PROJECT
// ═══════════════════════════════════════════════════════════════════════════════
function openNewProjectModal() {
  clearFields(['modal-proj-name','modal-proj-erp','modal-proj-client','modal-proj-start','modal-proj-golive','modal-proj-desc']);
  openModal('modal-project');
}
async function createProject() {
  var name = getField('modal-proj-name');
  if (!name) { alert('Project name is required'); return; }
  try {
    var d = await apiPost('/pm/projects', {
      name, erp_system: getField('modal-proj-erp'), client_name: getField('modal-proj-client'),
      start_date: getField('modal-proj-start') || null, go_live_date: getField('modal-proj-golive') || null,
      description: getField('modal-proj-desc')
    });
    if (d.project) {
      _projects.push(d.project);
      renderProjectSelector();
      closeModal('modal-project');
      document.getElementById('pm-project-select').value = d.project.id;
      await selectProject(d.project.id);
      showPage('project');
    } else { alert(d.error || 'Failed to create project'); }
  } catch(e) { alert(e.message); }
}

// ═══════════════════════════════════════════════════════════════════════════════
// TASKS
// ═══════════════════════════════════════════════════════════════════════════════
async function loadTasks() {
  if (!_project) return;
  var statusFilter   = (document.getElementById('task-filter-status')||{}).value || '';
  var priorityFilter = (document.getElementById('task-filter-priority')||{}).value || '';
  var path = '/pm/projects/' + _project.id + '/tasks';
  var params = [];
  if (statusFilter)   params.push('status=' + statusFilter);
  if (priorityFilter) params.push('priority=' + priorityFilter);
  if (params.length)  path += '?' + params.join('&');

  try {
    var d = await apiGet(path);
    _tasks = d.tasks || [];
    if (_taskViewMode === 'board') renderTaskBoard();
    else renderTaskList();
  } catch(e) {}
}

function renderTaskBoard() {
  var board = document.getElementById('task-board');
  if (!board) return;
  board.style.display = 'grid'; document.getElementById('task-list').style.display = 'none';
  var cols = { todo:'📝 Todo', pending:'⏳ Pending', in_progress:'🔄 In Progress', review:'👁️ Review', done:'✅ Done', cancelled:'🚫 Cancelled' };
  var html = '';
  Object.keys(cols).forEach(function(status) {
    var colTasks = _tasks.filter(function(t){ return t.status === status; });
    var today = new Date().toISOString().slice(0,10);
    html += '<div class="task-col"><div class="task-col-header">' + cols[status] + '<span class="task-col-count">' + colTasks.length + '</span></div>'
      + colTasks.map(function(t) {
        var isOverdue = t.due_date && t.due_date < today && status !== 'done';
        return '<div class="task-card" onclick="editTaskModal(\'' + t.id + '\')">'
          + '<div class="task-card-title">' + t.title + '</div>'
          + '<div class="task-card-meta">'
          + '<span class="badge badge-' + t.priority + '">' + t.priority + '</span>'
          + (t.due_date ? '<span class="task-card-due' + (isOverdue?' overdue':'') + '">📅 ' + t.due_date + '</span>' : '')
          + (t.pm_team_members ? '<span style="font-size:11px;color:var(--dim)">👤 ' + t.pm_team_members.full_name + '</span>' : '')
          + '<button class="btn-icon btn-sm" style="margin-left:auto" onclick="event.stopPropagation();deleteTask(\'' + t.id + '\')" title="Delete task">🗑️</button>'
          + '</div></div>';
      }).join('')
      + '</div>';
  });
  board.innerHTML = html;
}

function renderTaskList() {
  var list = document.getElementById('task-list');
  if (!list) return;
  list.style.display = 'block'; document.getElementById('task-board').style.display = 'none';
  if (!_tasks.length) { list.innerHTML = '<div class="pm-empty"><div class="pm-empty-icon">✅</div><h3>No tasks yet</h3></div>'; return; }
  var today = new Date().toISOString().slice(0,10);
  list.innerHTML = '<table style="width:100%;border-collapse:collapse;font-size:13px">'
    + '<thead><tr style="border-bottom:1px solid var(--border)"><th style="text-align:left;padding:8px 12px;color:var(--dim);font-size:11px">Task</th><th style="padding:8px 12px;color:var(--dim);font-size:11px">Status</th><th style="padding:8px 12px;color:var(--dim);font-size:11px">Priority</th><th style="padding:8px 12px;color:var(--dim);font-size:11px">Assigned</th><th style="padding:8px 12px;color:var(--dim);font-size:11px">Due</th><th style="padding:8px 12px;color:var(--dim);font-size:11px"></th></tr></thead>'
    + '<tbody>' + _tasks.map(function(t) {
      var isOverdue = t.due_date && t.due_date < today && !['done','cancelled'].includes(t.status);
      return '<tr style="border-bottom:1px solid var(--border2);cursor:pointer" onclick="editTaskModal(\'' + t.id + '\')">'
        + '<td style="padding:10px 12px"><div style="font-weight:600;color:var(--text)">' + t.title + '</div>' + (t.description ? '<div style="font-size:11px;color:var(--dim)">' + t.description.substring(0,60) + '</div>' : '') + '</td>'
        + '<td style="padding:10px 12px;text-align:center"><span class="badge badge-' + t.status + '">' + t.status.replace('_',' ') + '</span></td>'
        + '<td style="padding:10px 12px;text-align:center"><span class="badge badge-' + t.priority + '">' + t.priority + '</span></td>'
        + '<td style="padding:10px 12px;font-size:12px;color:var(--dim)">' + (t.pm_team_members ? t.pm_team_members.full_name : '—') + '</td>'
        + '<td style="padding:10px 12px;font-size:12px;color:' + (isOverdue?'var(--red)':'var(--dim)') + '">' + (t.due_date||'—') + '</td>'
        + '<td style="padding:10px 12px"><button class="btn-icon btn-sm" onclick="event.stopPropagation();deleteTask(\'' + t.id + '\')">🗑️</button></td>'
        + '</tr>';
    }).join('') + '</tbody></table>';
}

function toggleTaskView() {
  _taskViewMode = _taskViewMode === 'board' ? 'list' : 'board';
  document.getElementById('task-view-btn').textContent = _taskViewMode === 'board' ? '📋 List View' : '📊 Board View';
  if (_taskViewMode === 'board') renderTaskBoard(); else renderTaskList();
}

function openTaskModal() {
  if (!_project) { alert('Select a project first'); return; }
  _editingTaskId = null;
  clearFields(['task-title','task-description','task-phase','task-due','task-reminder']);
  setField('task-status', 'todo'); setField('task-priority', 'medium'); setField('task-assigned', '');
  setChecked('task-notify-assign', true); setChecked('task-notify-done', false);
  populateMemberSelect('task-assigned');
  document.getElementById('modal-task-title').textContent = 'New Task';
  document.getElementById('task-save-btn').textContent = 'Create Task';
  openModal('modal-task');
}

function editTaskModal(id) {
  var t = _tasks.find(function(x){ return x.id === id; });
  if (!t) return;
  _editingTaskId = id;
  setField('task-title', t.title);
  setField('task-status', t.status);
  setField('task-priority', t.priority);
  setField('task-phase', t.phase||'');
  setField('task-due', t.due_date||'');
  setField('task-reminder', t.reminder_at ? t.reminder_at.slice(0,16) : '');
  setField('task-description', t.description||'');
  setChecked('task-notify-assign', t.notify_on_assign !== false);
  setChecked('task-notify-done', !!t.notify_on_done);
  populateMemberSelect('task-assigned', t.assigned_to_id);
  document.getElementById('modal-task-title').textContent = 'Edit Task';
  document.getElementById('task-save-btn').textContent = 'Save Task';
  openModal('modal-task');
}

async function saveTask() {
  var title = getField('task-title');
  if (!title) { alert('Title is required'); return; }
  var body = {
    title, description: getField('task-description'), phase: getField('task-phase'),
    status: getField('task-status'), priority: getField('task-priority'),
    assigned_to_id: getField('task-assigned') || null,
    due_date: getField('task-due') || null,
    reminder_at: getField('task-reminder') ? new Date(getField('task-reminder')).toISOString() : null,
    notify_on_assign: isChecked('task-notify-assign'), notify_on_done: isChecked('task-notify-done'),
  };
  try {
    var d = _editingTaskId
      ? await apiPut('/pm/projects/' + _project.id + '/tasks/' + _editingTaskId, body)
      : await apiPost('/pm/projects/' + _project.id + '/tasks', body);
    if (d.task) { closeModal('modal-task'); await loadTasks(); }
    else alert(d.error || 'Failed');
  } catch(e) { alert(e.message); }
}

async function deleteTask(id) {
  if (!confirm('Delete this task?')) return;
  var res = await apiDelete('/pm/projects/' + _project.id + '/tasks/' + id);
  if (res && res.error) { alert('Could not delete task: ' + res.error); return; }
  await loadTasks();
}

// ═══════════════════════════════════════════════════════════════════════════════
// MEETINGS
// ═══════════════════════════════════════════════════════════════════════════════
async function loadMeetings() {
  if (!_project) return;
  var d = await apiGet('/pm/projects/' + _project.id + '/meetings');
  var meetings = d.meetings || [];
  var el = document.getElementById('meetings-list');
  if (!meetings.length) { el.innerHTML = '<div class="pm-empty"><div class="pm-empty-icon">📅</div><h3>No meetings scheduled</h3></div>'; return; }
  var today = new Date().toISOString().slice(0,10);
  var upcoming = meetings.filter(function(m){ return m.meeting_date >= today; });
  var past     = meetings.filter(function(m){ return m.meeting_date < today; });
  el.innerHTML = (upcoming.length ? '<div style="font-size:11px;font-weight:700;color:var(--dim);text-transform:uppercase;letter-spacing:.06em;margin-bottom:10px">Upcoming</div>' : '')
    + renderMeetingCards(upcoming, false)
    + (past.length ? '<div style="font-size:11px;font-weight:700;color:var(--dim);text-transform:uppercase;letter-spacing:.06em;margin:16px 0 10px">Past</div>' : '')
    + renderMeetingCards(past, true);
}

function renderMeetingCards(meetings, isPast) {
  return meetings.map(function(m) {
    var d = new Date(m.meeting_date);
    return '<div class="meeting-card" style="opacity:' + (isPast?'.6':'1') + '">'
      + '<div class="meeting-date-block"><div class="meeting-date-day">' + d.getDate() + '</div><div class="meeting-date-mon">' + d.toLocaleString('default',{month:'short'}).toUpperCase() + '</div></div>'
      + '<div class="meeting-info"><div class="meeting-title">' + m.title + '</div>'
      + '<div class="meeting-meta">'
      + (m.start_time ? '<span>⏰ ' + m.start_time + (m.end_time?' - '+m.end_time:'') + '</span>' : '')
      + (m.location  ? '<span>📍 ' + m.location + '</span>' : '')
      + (m.meeting_link ? '<span><a href="' + m.meeting_link + '" target="_blank" style="color:var(--gl)">🔗 Join</a></span>' : '')
      + '</div>'
      + (m.agenda ? '<div style="font-size:12px;color:var(--dim);margin-top:6px">' + m.agenda.substring(0,120) + '</div>' : '')
      + '</div>'
      + '<div style="display:flex;gap:6px;flex-direction:column">'
      + '<span class="badge badge-' + m.status + '" style="font-size:10px">' + m.status + '</span>'
      + '<button class="btn-icon btn-sm" onclick="deleteMeeting(\'' + m.id + '\')">🗑️</button>'
      + '</div></div>';
  }).join('');
}

function openMeetingModal() {
  _editingMeetingId = null;
  clearFields(['meeting-title','meeting-date','meeting-start','meeting-end','meeting-location','meeting-link','meeting-agenda','meeting-timezone']);
  clearEmailTags('meeting-ext-tags', 'meeting-ext-list');
  renderMeetingAttendees([]);
  document.getElementById('meeting-send-invites').checked = true;
  openModal('modal-meeting');
}

function renderMeetingAttendees(selectedIds) {
  var el = document.getElementById('meeting-attendees-list');
  if (!el) return;
  el.innerHTML = _members.map(function(m) {
    var checked = selectedIds.includes(m.id);
    return '<label style="display:flex;align-items:center;gap:6px;padding:5px 10px;background:var(--bg2);border:1px solid var(--border);border-radius:20px;cursor:pointer;font-size:12px">'
      + '<input type="checkbox" value="' + m.id + '" ' + (checked?'checked':'') + '> ' + m.full_name + '</label>';
  }).join('');
}

async function saveMeeting() {
  var title = getField('meeting-title'), date = getField('meeting-date');
  if (!title || !date) { alert('Title and date are required'); return; }
  var attendeeCheckboxes = document.querySelectorAll('#meeting-attendees-list input[type=checkbox]:checked');
  var attendeeIds = Array.from(attendeeCheckboxes).map(function(cb){ return cb.value; });
  var extList = getField('meeting-ext-list');
  var externalAttendees = extList ? extList.split(',').filter(Boolean) : [];
  var body = {
    title, meeting_date: date, start_time: getField('meeting-start')||null,
    end_time: getField('meeting-end')||null, timezone: getField('meeting-timezone')||'UTC',
    location: getField('meeting-location'), meeting_link: getField('meeting-link'),
    agenda: getField('meeting-agenda'), attendee_ids: attendeeIds,
    external_attendees: externalAttendees, send_invites: isChecked('meeting-send-invites'),
  };
  try {
    var d = await apiPost('/pm/projects/' + _project.id + '/meetings', body);
    if (d.meeting) { closeModal('modal-meeting'); await loadMeetings(); }
    else alert(d.error || 'Failed');
  } catch(e) { alert(e.message); }
}

async function deleteMeeting(id) {
  if (!confirm('Delete this meeting?')) return;
  await apiDelete('/pm/projects/' + _project.id + '/meetings/' + id);
  await loadMeetings();
}

// ═══════════════════════════════════════════════════════════════════════════════
// MEMBERS
// ═══════════════════════════════════════════════════════════════════════════════
function openMemberModal() {
  _editingMemberId = null;
  clearFields(['member-name','member-title','member-dept','member-email','member-phone','member-mobile','member-linkedin','member-joined','member-note']);
  setField('member-role','member'); setChecked('member-external', false);
  renderTagsFromValue('member-modules-tags', 'member-modules', []);
  document.getElementById('modal-member-title').textContent = 'Add Team Member';
  document.getElementById('member-save-btn').textContent = 'Add Member';
  openModal('modal-member');
}

function editMember(id) {
  var m = _members.find(function(x){ return x.id === id; });
  if (!m) return;
  _editingMemberId = id;
  setField('member-name', m.full_name); setField('member-title', m.title||'');
  setField('member-role', m.role||'member'); setField('member-dept', m.department||'');
  setField('member-email', m.email||''); setField('member-phone', m.phone||'');
  setField('member-mobile', m.mobile||''); setField('member-linkedin', m.linkedin||'');
  setField('member-joined', m.joined_date||''); setField('member-note', m.note||'');
  setChecked('member-external', !!m.is_external);
  renderTagsFromValue('member-modules-tags', 'member-modules', m.erp_modules||[]);
  document.getElementById('modal-member-title').textContent = 'Edit Member';
  document.getElementById('member-save-btn').textContent = 'Save Member';
  openModal('modal-member');
}

async function saveMember() {
  var name = getField('member-name');
  if (!name) { alert('Name is required'); return; }
  var mods = (getField('member-modules')||'').split(',').map(function(s){ return s.trim(); }).filter(Boolean);
  var body = {
    full_name: name, title: getField('member-title'), role: getField('member-role'),
    department: getField('member-dept'), email: getField('member-email'),
    phone: getField('member-phone'), mobile: getField('member-mobile'),
    linkedin: getField('member-linkedin'), joined_date: getField('member-joined')||null,
    note: getField('member-note'), is_external: isChecked('member-external'), erp_modules: mods,
  };
  try {
    var d = _editingMemberId
      ? await apiPut('/pm/projects/' + _project.id + '/members/' + _editingMemberId, body)
      : await apiPost('/pm/projects/' + _project.id + '/members', body);
    if (d.member) {
      if (_editingMemberId) { var idx = _members.findIndex(function(m){ return m.id === _editingMemberId; }); if (idx>=0) _members[idx] = d.member; }
      else _members.push(d.member);
      closeModal('modal-member'); renderMembersList();
    } else alert(d.error || 'Failed');
  } catch(e) { alert(e.message); }
}

async function deleteMember(id, name) {
  if (!confirm('Remove ' + name + ' from the team?')) return;
  await apiDelete('/pm/projects/' + _project.id + '/members/' + id);
  _members = _members.filter(function(m){ return m.id !== id; });
  renderMembersList();
}

// ═══════════════════════════════════════════════════════════════════════════════
// DOCUMENTS
// ═══════════════════════════════════════════════════════════════════════════════
var _docs = [];

async function loadDocuments() {
  if (!_project) return;
  var listEl = document.getElementById('documents-list');
  var viewEl = document.getElementById('doc-viewer');
  if (listEl) listEl.style.display = 'block';
  if (viewEl) viewEl.style.display = 'none';
  listEl.innerHTML = '<div class="pm-loading"><div class="pm-spinner"></div> Loading...</div>';
  var d = await apiGet('/pm/projects/' + _project.id + '/documents');
  _docs = d.documents || [];
  if (!_docs.length) { listEl.innerHTML = '<div class="pm-empty"><div class="pm-empty-icon">📄</div><h3>No documents yet</h3><p>Generate AI documents or write manually</p></div>'; return; }

  var docTypeIcons = { project_charter:'📋', project_plan:'📅', gap_analysis:'🔍', brd:'📑', fsd:'⚙️', test_plan:'🧪', uat_plan:'✅', training_plan:'📚', cutover_plan:'🚀', sign_off:'✍️', status_report:'📊', risk_register:'⚠️', change_request:'🔄', meeting_minutes:'📝', other:'📄' };

  listEl.innerHTML = _docs.map(function(doc) {
    var icon = docTypeIcons[doc.type] || '📄';
    return '<div class="doc-row" onclick="openDocViewer(\'' + doc.id + '\')">'
      + '<div class="doc-icon">' + icon + '</div>'
      + '<div class="doc-info"><div class="doc-title">' + doc.title + '</div>'
      + '<div class="doc-meta">' + doc.type.replace(/_/g,' ') + ' · v' + (doc.version||1) + ' · '
      + '<span class="badge badge-' + doc.status + '" style="font-size:10px">' + doc.status + '</span>'
      + ' · ' + new Date(doc.created_at).toLocaleDateString() + '</div></div>'
      + '<div class="doc-actions"><button class="btn-icon btn-sm" onclick="event.stopPropagation();deleteDoc(\'' + doc.id + '\')">🗑️</button></div></div>';
  }).join('');
}

async function openDocViewer(id) {
  _currentDocId = id;
  var d = await apiGet('/pm/projects/' + _project.id + '/documents/' + id);
  if (!d.document) return;
  document.getElementById('documents-list').style.display = 'none';
  document.getElementById('doc-viewer').style.display = 'block';
  document.getElementById('doc-viewer-title').textContent = d.document.title;
  document.getElementById('doc-viewer-content').value = d.document.content || '';
  document.getElementById('doc-viewer-status').value = d.document.status || 'draft';
}

function closeDocViewer() {
  _currentDocId = null;
  document.getElementById('documents-list').style.display = 'block';
  document.getElementById('doc-viewer').style.display = 'none';
}

function markDocDirty() {} // could track unsaved changes

async function saveDocContent() {
  if (!_currentDocId) return;
  var content = document.getElementById('doc-viewer-content').value;
  var status  = document.getElementById('doc-viewer-status').value;
  var d = await apiPut('/pm/projects/' + _project.id + '/documents/' + _currentDocId, { content, status });
  if (d.document) alert('✅ Saved!');
  else alert(d.error || 'Failed');
}

async function deleteDoc(id) {
  if (!confirm('Delete this document?')) return;
  await apiDelete('/pm/projects/' + _project.id + '/documents/' + id);
  if (_currentDocId === id) closeDocViewer();
  await loadDocuments();
}

async function deleteCurrentDoc() {
  if (_currentDocId) await deleteDoc(_currentDocId);
}

function copyDocContent() {
  var content = document.getElementById('doc-viewer-content').value;
  navigator.clipboard.writeText(content).then(function(){ alert('Copied to clipboard'); });
}

function downloadDocContent() {
  var content = document.getElementById('doc-viewer-content').value;
  var title   = document.getElementById('doc-viewer-title').textContent || 'document';
  var blob = new Blob([content], { type: 'text/plain' });
  var a = document.createElement('a');
  a.href = URL.createObjectURL(blob); a.download = title.replace(/[^a-z0-9]/gi,'_') + '.txt';
  a.click();
}

function openGenerateDocModal() {
  clearFields(['gen-doc-phase','gen-doc-title']);
  setField('gen-doc-type', 'project_charter');
  // Reset format to Save Only
  var saveRadio = document.querySelector('input[name="gen-doc-format"][value="save"]');
  if (saveRadio) { saveRadio.checked = true; _updateDocFormatUI('save'); }
  // Attach format radio listeners
  document.querySelectorAll('input[name="gen-doc-format"]').forEach(function(r) {
    r.onchange = function() { _updateDocFormatUI(r.value); };
  });
  document.getElementById('gen-doc-btn').textContent = '🤖 Generate';
  document.getElementById('gen-doc-btn').disabled = false;
  openModal('modal-gen-doc');
}

function _updateDocFormatUI(fmt) {
  var labels = { save:'💾 Save Only', docx:'📄 Word (.docx)', pdf:'📋 PDF (.pdf)', pptx:'📊 PowerPoint (.pptx)' };
  var hints  = {
    save: 'Document will be saved to your Documents tab.',
    docx: 'AI generates content, then downloads as a formatted Word document.',
    pdf:  'AI generates content, then downloads as a styled PDF.',
    pptx: 'AI generates content, then downloads as a PowerPoint presentation.',
  };
  ['save','docx','pdf','pptx'].forEach(function(f) {
    var lbl = document.getElementById('fmt-' + f + '-lbl');
    if (!lbl) return;
    var active = f === fmt;
    lbl.style.borderColor = active ? 'var(--gl)' : 'var(--border)';
    lbl.style.background  = active ? 'rgba(10,138,95,.08)' : 'var(--bg3)';
    var nameEl = lbl.querySelector('div:nth-child(3)');
    if (nameEl) nameEl.style.color = active ? 'var(--gl)' : 'var(--text)';
  });
  var hint = document.getElementById('gen-doc-format-hint');
  if (hint) hint.textContent = hints[fmt] || '';
  var btn = document.getElementById('gen-doc-btn');
  if (btn) btn.textContent = fmt === 'save' ? '🤖 Generate' : '🤖 Generate & Download';
}

async function generateDocument() {
  var btn = document.getElementById('gen-doc-btn');
  var fmt = (document.querySelector('input[name="gen-doc-format"]:checked') || {}).value || 'save';
  btn.textContent = '⏳ Generating...'; btn.disabled = true;

  var body = {
    type:          getField('gen-doc-type'),
    phase:         getField('gen-doc-phase'),
    title:         getField('gen-doc-title') || null,
    export_format: fmt === 'save' ? null : fmt,
  };

  try {
    var response = await fetch(API + '/pm/projects/' + _project.id + '/documents/generate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + _token },
      body: JSON.stringify(body)
    });

    if (!response.ok) {
      var errData = await response.json().catch(function(){ return {}; });
      alert(errData.error || 'Generation failed (HTTP ' + response.status + ')');
      return;
    }

    // ── Read SSE stream ────────────────────────────────────────────────────
    var reader = response.body.getReader();
    var decoder = new TextDecoder();
    var buffer = '';
    var result = null;

    while (true) {
      var chunk = await reader.read();
      if (chunk.done) break;
      buffer += decoder.decode(chunk.value, { stream: true });
      var lines = buffer.split('\n');
      buffer = lines.pop(); // keep any incomplete line
      for (var i = 0; i < lines.length; i++) {
        var line = lines[i];
        if (!line.startsWith('data: ')) continue;
        try {
          var ev = JSON.parse(line.slice(6));
          if (ev.type === 'progress') {
            btn.textContent = '⏳ ' + (ev.message || 'Generating...');
          } else if (ev.type === 'heartbeat') {
            btn.textContent = '⏳ Writing... (' + ev.chars + ' chars)';
          } else if (ev.type === 'done') {
            result = ev;
          } else if (ev.type === 'error') {
            alert(ev.error || 'Generation failed');
            return;
          }
        } catch(_) { /* skip malformed SSE line */ }
      }
    }

    if (!result || !result.document) {
      alert('Generation failed — no result received. Please try again.');
      return;
    }

    // ── Success ────────────────────────────────────────────────────────────
    await loadDocuments();
    closeModal('modal-gen-doc');

    if (fmt !== 'save' && result.export_format) {
      btn.textContent = '⏳ Downloading...';
      await exportDoc(fmt, result.document.id);
    } else {
      openDocViewer(result.document.id);
    }
  } catch(e) { alert(e.message); }
  finally { btn.textContent = fmt === 'save' ? '🤖 Generate' : '🤖 Generate & Download'; btn.disabled = false; }
}

function openNewDocModal() {
  // Manual document — open viewer with empty content
  openGenerateDocModal(); // for now reuse, can be customized
}

// ═══════════════════════════════════════════════════════════════════════════════
// EMAIL
// ═══════════════════════════════════════════════════════════════════════════════
async function loadEmailLog() {
  if (!_project) return;
  var el = document.getElementById('email-log');
  el.innerHTML = '<div class="pm-loading"><div class="pm-spinner"></div></div>';
  var d = await apiGet('/pm/projects/' + _project.id + '/emails');
  var emails = d.emails || [];
  if (!emails.length) { el.innerHTML = '<div style="color:var(--dim);font-size:13px;padding:10px">No emails sent yet</div>'; return; }
  el.innerHTML = emails.map(function(e) {
    return '<div style="padding:10px 0;border-bottom:1px solid var(--border2)">'
      + '<div style="font-size:12px;font-weight:600;color:var(--text)">' + e.subject + '</div>'
      + '<div style="font-size:11px;color:var(--dim);margin-top:2px">To: ' + (e.to_emails||[]).join(', ') + '</div>'
      + '<div style="display:flex;align-items:center;gap:8px;margin-top:4px">'
      + '<span class="badge badge-' + (e.status==='sent'?'done':'cancelled') + '" style="font-size:10px">' + e.status + '</span>'
      + '<span style="font-size:10px;color:var(--dim)">' + new Date(e.sent_at).toLocaleString() + '</span></div></div>';
  }).join('');
}

async function sendEmail() {
  // Commit any address still typed in the TO/CC boxes (not yet turned into a chip),
  // so a typed-but-not-Entered email isn't silently dropped on send.
  flushEmailInput('email-to-tags', 'email-to-list');
  flushEmailInput('email-cc-tags', 'email-cc-list');

  var toList  = getField('email-to-list');
  var subject = getField('email-subject');
  var editor  = document.getElementById('email-body-editor');
  var htmlBody = editor ? editor.innerHTML.trim() : '';
  var textBody = editor ? (editor.innerText || editor.textContent || '').trim() : '';
  if (!toList || !subject || !textBody) { showAlert('email-alert', 'error', 'To, Subject and Body are required'); return; }
  var ccList    = getField('email-cc-list');
  var attachIds = (document.getElementById('email-attach-ids')?.value || '').split(',').filter(Boolean);

  // Encode uploaded files as base64
  var fileAttachments = [];
  try {
    var fileReadPromises = (_emailUploadedFiles || []).map(function(file) {
      return new Promise(function(resolve) {
        var reader = new FileReader();
        reader.onload = function(e) {
          resolve({ name: file.name, type: file.type, base64: e.target.result.split(',')[1] });
        };
        reader.readAsDataURL(file);
      });
    });
    fileAttachments = await Promise.all(fileReadPromises);
  } catch(_) {}

  var statusEl = document.getElementById('email-send-status');
  if (statusEl) { statusEl.style.color = 'var(--dim)'; statusEl.textContent = 'Sending...'; }

  try {
    var d = await apiPost('/pm/projects/' + _project.id + '/emails/send', {
      to_emails:      toList.split(',').filter(Boolean),
      cc_emails:      ccList ? ccList.split(',').filter(Boolean) : [],
      subject, body: textBody, html_body: htmlBody,
      type: 'manual', attach_doc_ids: attachIds,
      file_attachments: fileAttachments
    });
    if (d.sent) {
      showAlert('email-alert', 'success', '✅ Email sent successfully');
      setField('email-subject', '');
      if (editor) editor.innerHTML = '';
      clearEmailTags('email-to-tags','email-to-list');
      clearEmailTags('email-cc-tags','email-cc-list');
      var attachEl = document.getElementById('email-attach-ids');
      if (attachEl) attachEl.value = '';
      _emailUploadedFiles = [];
      var wrap = document.getElementById('email-attachments-wrap');
      if (wrap) { wrap.style.display = 'none'; }
      var alist = document.getElementById('email-attachments-list');
      if (alist) alist.innerHTML = '';
      var ufiles = document.getElementById('email-uploaded-files');
      if (ufiles) ufiles.innerHTML = '';
      if (statusEl) statusEl.textContent = '';
      loadEmailLog();
    } else {
      showAlert('email-alert', 'error', 'Failed: ' + (d.error || 'Unknown error'));
      if (statusEl) statusEl.textContent = '';
    }
  } catch(e) { showAlert('email-alert', 'error', e.message); if (statusEl) statusEl.textContent = ''; }
}

function addTeamToEmail() {
  (_members || []).forEach(function(m) {
    if (m.email) addEmailTagValue('email-to-tags', 'email-to-list', m.email);
  });
}

function emailExecFormat(cmd, val) {
  var editor = document.getElementById('email-body-editor');
  if (editor) editor.focus();
  document.execCommand(cmd, false, val || null);
  syncEmailBody();
}

function syncEmailBody() {
  var editor = document.getElementById('email-body-editor');
  var ta = document.getElementById('email-body');
  if (editor && ta) ta.value = editor.innerHTML;
}

function emailInsertGreeting() {
  var editor = document.getElementById('email-body-editor');
  if (!editor) return;
  editor.focus();
  var cur = editor.innerHTML.trim();
  editor.innerHTML = '<p>Dear Team,</p><p>I hope this message finds you well.</p><p><br></p>' + cur;
  syncEmailBody();
}

function emailInsertSignature() {
  var editor = document.getElementById('email-body-editor');
  if (!editor) return;
  editor.focus();
  editor.innerHTML = (editor.innerHTML || '').trimEnd() + '<p><br></p><p>Best regards,<br><strong>ERP Online Hub PM</strong></p>';
  syncEmailBody();
}

var _emailUploadedFiles = [];

function handleEmailFileUpload(input) {
  var files = Array.from(input.files || []);
  var wrap = document.getElementById('email-attachments-wrap');
  var uploadedDiv = document.getElementById('email-uploaded-files');
  if (!files.length || !uploadedDiv) return;
  files.forEach(function(file) {
    _emailUploadedFiles.push(file);
    var tag = document.createElement('div');
    tag.style.cssText = 'display:flex;align-items:center;gap:6px;padding:5px 10px;background:var(--bg2);border:1px solid var(--border);border-radius:6px;font-size:12px';
    tag.innerHTML = '📎 ' + file.name + ' <span style="color:var(--dim);font-size:10px">(' + (file.size/1024).toFixed(0) + ' KB)</span>'
      + '<button onclick="removeUploadedFile(this,\'' + file.name + '\')" style="background:none;border:none;color:var(--red);cursor:pointer;font-size:14px;padding:0 2px">×</button>';
    uploadedDiv.appendChild(tag);
  });
  if (wrap) wrap.style.display = 'block';
  input.value = '';
}

function removeUploadedFile(btn, name) {
  _emailUploadedFiles = _emailUploadedFiles.filter(function(f){ return f.name !== name; });
  btn.closest('div').remove();
  var uploadedDiv = document.getElementById('email-uploaded-files');
  var attachList  = document.getElementById('email-attachments-list');
  var wrap = document.getElementById('email-attachments-wrap');
  if (wrap && !_emailUploadedFiles.length && !(attachList && attachList.querySelector('input:checked'))) {
    wrap.style.display = 'none';
  }
}

function emailAttachDoc() {
  var docs = _docs || [];
  var wrap = document.getElementById('email-attachments-wrap');
  var list = document.getElementById('email-attachments-list');
  if (!docs.length) { showAlert('email-alert', 'info', 'No documents in this project yet.'); return; }
  var existing = (document.getElementById('email-attach-ids')?.value || '').split(',').filter(Boolean);
  list.innerHTML = docs.map(function(d) {
    var checked = existing.includes(d.id) ? 'checked' : '';
    return '<label style="display:flex;align-items:center;gap:8px;padding:6px 10px;background:var(--bg2);border:1px solid var(--border);border-radius:7px;cursor:pointer;font-size:12px">'
      + '<input type="checkbox" value="' + d.id + '" ' + checked + ' onchange="updateEmailAttachList()">'
      + '📄 ' + (d.title || 'Document')
      + ' <span style="font-size:10px;color:var(--dim);background:var(--bg3);padding:1px 6px;border-radius:10px">' + (d.type||'').replace(/_/g,' ') + '</span>'
      + '</label>';
  }).join('');
  if (wrap) wrap.style.display = 'block';
  updateEmailAttachList();
}

function updateEmailAttachList() {
  var checked = Array.from(document.querySelectorAll('#email-attachments-list input[type=checkbox]:checked'));
  var ids = checked.map(function(c){ return c.value; }).join(',');
  var hiddenEl = document.getElementById('email-attach-ids');
  if (hiddenEl) hiddenEl.value = ids;
  var btn = document.getElementById('btn-attach-doc');
  if (btn) btn.textContent = '📄 ' + (ids ? 'Docs (' + checked.length + ')' : 'Attach Doc');
}

function openAiComposeModal() { clearFields(['ai-email-purpose','ai-email-recipient','ai-email-role','ai-email-notes']); openModal('modal-ai-compose'); }

async function aiComposeEmail() {
  var purpose = getField('ai-email-purpose');
  if (!purpose) { alert('Purpose is required'); return; }
  try {
    var d = await apiPost('/pm/projects/' + _project.id + '/emails/compose', {
      purpose, recipient_name: getField('ai-email-recipient'),
      recipient_role: getField('ai-email-role'), custom_notes: getField('ai-email-notes')
    });
    if (d.subject && d.body) {
      setField('email-subject', d.subject);
      var editor = document.getElementById('email-body-editor');
      if (editor) {
        editor.innerHTML = d.body.replace(/\n/g, '<br>');
        syncEmailBody();
      } else {
        setField('email-body', d.body);
      }
      closeModal('modal-ai-compose');
    } else alert(d.error || 'Failed');
  } catch(e) { alert(e.message); }
}

// ═══════════════════════════════════════════════════════════════════════════════
// ANALYSIS
// ═══════════════════════════════════════════════════════════════════════════════
async function runAnalysis(generateTasks) {
  if (!_project) { alert('Select a project first'); return; }
  document.getElementById('analysis-result').style.display = 'none';
  document.getElementById('analysis-loading').style.display = 'flex';
  document.getElementById('analysis-btn').disabled = true;
  document.getElementById('analysis-tasks-btn').disabled = true;

  var loadingMsg = document.querySelector('#analysis-loading span') || document.getElementById('analysis-loading');

  function setMsg(msg) {
    if (loadingMsg) loadingMsg.textContent = msg;
  }

  try {
    var response = await fetch(API + '/pm/projects/' + _project.id + '/analyze', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + _token },
      body: JSON.stringify({ generate_tasks: generateTasks })
    });

    if (!response.ok) {
      var errData = await response.json().catch(function(){ return {}; });
      alert('Analysis failed: ' + (errData.error || 'HTTP ' + response.status));
      return;
    }

    // ── Read SSE stream ──────────────────────────────────────────────────────
    var reader = response.body.getReader();
    var decoder = new TextDecoder();
    var buffer = '';
    var result = null;

    while (true) {
      var chunk = await reader.read();
      if (chunk.done) break;
      buffer += decoder.decode(chunk.value, { stream: true });
      var lines = buffer.split('\n');
      buffer = lines.pop();
      for (var i = 0; i < lines.length; i++) {
        var line = lines[i];
        if (!line.startsWith('data: ')) continue;
        try {
          var ev = JSON.parse(line.slice(6));
          if (ev.type === 'progress')   { setMsg(ev.message || 'Analyzing...'); }
          else if (ev.type === 'heartbeat') { setMsg('Analyzing... (' + ev.chars + ' chars)'); }
          else if (ev.type === 'done')  { result = ev; }
          else if (ev.type === 'error') { alert('Analysis failed: ' + ev.error); return; }
        } catch(_) {}
      }
    }

    if (!result) { alert('Analysis failed — no result received. Please try again.'); return; }

    // ── Render result ────────────────────────────────────────────────────────
    document.getElementById('analysis-loading').style.display = 'none';
    document.getElementById('analysis-result').style.display = 'block';

    var scoreMatch = result.analysis.match(/health\s*score[:\s]+(\d+)/i);
    var score = scoreMatch ? parseInt(scoreMatch[1]) : null;
    var scoreColor = score >= 75 ? 'var(--gl)' : score >= 50 ? 'var(--gold)' : 'var(--red)';
    document.getElementById('analysis-health').innerHTML = score !== null
      ? '<div class="health-circle" style="background:' + scoreColor + '20;color:' + scoreColor + '">' + score + '</div>'
        + '<div><div style="font-size:16px;font-weight:700;color:var(--text)">Project Health Score</div>'
        + '<div style="font-size:13px;color:var(--dim);margin-top:4px">Based on tasks, team, timeline, and deliverables</div></div>'
      : '';
    document.getElementById('analysis-output').textContent = result.analysis;

    if (generateTasks && result.auto_tasks && result.auto_tasks.length) {
      document.getElementById('analysis-auto-tasks').style.display = 'block';
      document.getElementById('analysis-tasks-list').innerHTML = result.auto_tasks.map(function(t) {
        return '<div style="display:flex;align-items:center;gap:10px;padding:8px 0;border-bottom:1px solid var(--border2)">'
          + '<span class="badge badge-' + t.priority + '">' + t.priority + '</span>'
          + '<div><div style="font-size:13px;font-weight:600;color:var(--text)">' + t.title + '</div>'
          + (t.due_date ? '<div style="font-size:11px;color:var(--dim)">Due: ' + t.due_date + '</div>' : '')
          + '</div></div>';
      }).join('');
      await loadTasks();
    }
  } catch(e) {
    document.getElementById('analysis-loading').style.display = 'none';
    alert('Analysis failed: ' + e.message);
  } finally {
    document.getElementById('analysis-btn').disabled = false;
    document.getElementById('analysis-tasks-btn').disabled = false;
  }
}

async function exportAnalysis(format) {
  var outputEl = document.getElementById('analysis-output');
  var healthEl = document.getElementById('analysis-health');
  if (!outputEl || !outputEl.textContent.trim()) {
    alert('Run an analysis first before exporting.'); return;
  }

  var fmtLabel = format === 'pdf' ? 'PDF' : 'Word';
  var btn = document.querySelector('button[onclick="exportAnalysis(\'' + format + '\')"]');
  if (btn) { btn.textContent = '⏳ Generating...'; btn.disabled = true; }

  try {
    // Extract health score from the health circle
    var scoreMatch = healthEl ? healthEl.textContent.match(/\d+/) : null;
    var healthScore = scoreMatch ? parseInt(scoreMatch[0]) : null;

    var r = await fetch(API + '/pm/projects/' + _project.id + '/analysis/export', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + _token },
      body: JSON.stringify({
        format:        format,
        analysis_text: outputEl.textContent,
        health_score:  healthScore,
        project_name:  _project.name
      })
    });

    if (!r.ok) {
      var err = await r.json().catch(function(){ return {}; });
      alert('Export failed: ' + (err.error || r.status));
      return;
    }

    var blob  = await r.blob();
    var url   = URL.createObjectURL(blob);
    var a     = document.createElement('a');
    a.href     = url;
    a.download = (_project.name || 'analysis').replace(/[^a-z0-9]/gi,'_') + '_AI_Analysis.' + format;
    document.body.appendChild(a); a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  } catch(e) {
    alert('Export error: ' + e.message);
  } finally {
    if (btn) {
      btn.textContent = format === 'pdf' ? '📋 Export PDF' : '📄 Export Word';
      btn.disabled = false;
    }
  }
}

// ═══════════════════════════════════════════════════════════════════════════════
// HELPERS — Modal, Fields, Tags
// ═══════════════════════════════════════════════════════════════════════════════
function openModal(id)  { var m = document.getElementById(id); if (m) m.classList.add('open'); }
function closeModal(id) { var m = document.getElementById(id); if (m) m.classList.remove('open'); }
function show(id) {
  var el = document.getElementById(id);
  if (!el) return;
  // pm-app is a flex container — must use display:flex not display:block
  el.style.display = (id === 'pm-app') ? 'flex' : 'block';
}
function hide(id) { var el = document.getElementById(id); if (el) el.style.display = 'none'; }
function getField(id) { var el = document.getElementById(id); return el ? el.value : ''; }
function setField(id, val) { var el = document.getElementById(id); if (el) el.value = val || ''; }
function isChecked(id) { var el = document.getElementById(id); return el ? el.checked : false; }
function setChecked(id, val) { var el = document.getElementById(id); if (el) el.checked = !!val; }
function clearFields(ids) { ids.forEach(function(id){ setField(id,''); }); }

function showAlert(id, type, msg) {
  var el = document.getElementById(id); if (!el) return;
  el.className = 'pm-alert show ' + type; el.textContent = msg;
  setTimeout(function(){ el.classList.remove('show'); }, 5000);
}

function populateMemberSelect(selectId, selectedId) {
  var sel = document.getElementById(selectId); if (!sel) return;
  sel.innerHTML = '<option value="">Unassigned</option>';
  _members.forEach(function(m) {
    var opt = document.createElement('option');
    opt.value = m.id; opt.textContent = m.full_name + (m.title ? ' (' + m.title + ')' : '');
    if (selectedId && m.id === selectedId) opt.selected = true;
    sel.appendChild(opt);
  });
}

// Tags input — modules
function addModuleTag(event, hiddenId) {
  if (event.key !== 'Enter' && event.key !== ',') return;
  event.preventDefault();
  var input = event.target;
  var val = input.value.trim();
  if (!val) return;
  var hidden = document.getElementById(hiddenId);
  var existing = hidden.value ? hidden.value.split(',') : [];
  if (existing.includes(val)) { input.value = ''; return; }
  existing.push(val);
  hidden.value = existing.join(',');
  var tag = document.createElement('div'); tag.className = 'tag-item';
  tag.innerHTML = val + '<button type="button" onclick="removeModuleTag(this,\'' + hiddenId + '\')">×</button>';
  input.parentNode.insertBefore(tag, input); input.value = '';
}
function removeModuleTag(btn, hiddenId) {
  var val = btn.parentNode.textContent.replace('×','').trim();
  var hidden = document.getElementById(hiddenId);
  hidden.value = (hidden.value||'').split(',').filter(function(v){ return v.trim() !== val; }).join(',');
  btn.parentNode.remove();
}
function renderTagsFromValue(containerID, hiddenId, arr) {
  var container = document.getElementById(containerID); if (!container) return;
  var input = container.querySelector('input');
  container.querySelectorAll('.tag-item').forEach(function(t){ t.remove(); });
  var hidden = document.getElementById(hiddenId); if (hidden) hidden.value = '';
  arr.forEach(function(val) {
    if (!val) return;
    var tag = document.createElement('div'); tag.className = 'tag-item';
    tag.innerHTML = val + '<button type="button" onclick="removeModuleTag(this,\'' + hiddenId + '\')">×</button>';
    container.insertBefore(tag, input);
  });
  if (hidden) hidden.value = arr.join(',');
}

// Email tags
function addEmailTag(event, hiddenId) {
  if (event.key !== 'Enter' && event.key !== ',') return;
  event.preventDefault();
  var input = event.target;
  var val = input.value.trim();
  if (!val || !val.includes('@')) return;
  addEmailTagValue(input.closest('[id]')?.id || event.target.parentNode.id, hiddenId, val);
  input.value = '';
}
function addEmailTagValue(containerID, hiddenId, val) {
  var container = document.getElementById(containerID); if (!container) return;
  var input = container.querySelector('input');
  var hidden = document.getElementById(hiddenId);
  var existing = hidden && hidden.value ? hidden.value.split(',') : [];
  if (existing.includes(val)) return;
  existing.push(val);
  if (hidden) hidden.value = existing.join(',');
  var tag = document.createElement('div'); tag.className = 'email-tag';
  tag.innerHTML = val + '<button type="button" onclick="removeEmailTag(this,\'' + hiddenId + '\')">×</button>';
  container.insertBefore(tag, input);
}
function removeEmailTag(btn, hiddenId) {
  var val = btn.parentNode.textContent.replace('×','').trim();
  var hidden = document.getElementById(hiddenId);
  if (hidden) hidden.value = (hidden.value||'').split(',').filter(function(v){ return v.trim() !== val; }).join(',');
  btn.parentNode.remove();
}
function clearEmailTags(containerID, hiddenId) {
  var container = document.getElementById(containerID); if (!container) return;
  container.querySelectorAll('.email-tag').forEach(function(t){ t.remove(); });
  var hidden = document.getElementById(hiddenId); if (hidden) hidden.value = '';
}

// Commit whatever is still typed in an email chip-input as a tag (used on send + blur),
// so a typed-but-not-Entered address isn't dropped.
function flushEmailInput(containerID, hiddenId) {
  var container = document.getElementById(containerID); if (!container) return;
  var input = container.querySelector('input');
  var val = input && input.value ? input.value.trim() : '';
  if (val) { addEmailTagValue(containerID, hiddenId, val); input.value = ''; }
}

// Close modals on backdrop click
document.addEventListener('click', function(e) {
  if (e.target.classList.contains('pm-modal')) e.target.classList.remove('open');
});

// Expose to window for inline onclick
window.showPage = showPage; window.selectProject = selectProject;
window.openNewProjectModal = openNewProjectModal; window.createProject = createProject;
window.saveProject = saveProject; window.addPhase = addPhase; window.removePhase = removePhase;
window.openMemberModal = openMemberModal; window.editMember = editMember; window.saveMember = saveMember; window.deleteMember = deleteMember;
window.openTaskModal = openTaskModal; window.editTaskModal = editTaskModal; window.saveTask = saveTask; window.deleteTask = deleteTask; window.loadTasks = loadTasks; window.toggleTaskView = toggleTaskView;
window.openMeetingModal = openMeetingModal; window.saveMeeting = saveMeeting; window.deleteMeeting = deleteMeeting;
window.openGenerateDocModal = openGenerateDocModal; window.generateDocument = generateDocument; window.openNewDocModal = openNewDocModal;
window._updateDocFormatUI = _updateDocFormatUI;
window.openDocViewer = openDocViewer; window.closeDocViewer = closeDocViewer; window.saveDocContent = saveDocContent; window.copyDocContent = copyDocContent; window.downloadDocContent = downloadDocContent; window.deleteDoc = deleteDoc; window.deleteCurrentDoc = deleteCurrentDoc; window.markDocDirty = markDocDirty;
window.sendEmail = sendEmail;
window.addTeamToEmail = addTeamToEmail;
window.emailExecFormat = emailExecFormat;
window.syncEmailBody = syncEmailBody;
window.emailInsertGreeting = emailInsertGreeting;
window.emailInsertSignature = emailInsertSignature;
window.emailAttachDoc = emailAttachDoc;
window.updateEmailAttachList = updateEmailAttachList;
window.handleEmailFileUpload = handleEmailFileUpload;
window.removeUploadedFile = removeUploadedFile;
window.openAiComposeModal = openAiComposeModal;
window.aiComposeEmail = aiComposeEmail;
window.runAnalysis    = runAnalysis;
window.exportAnalysis = exportAnalysis;
window.openModal = openModal; window.closeModal = closeModal;
window.addModuleTag = addModuleTag; window.removeModuleTag = removeModuleTag;
window.addEmailTag = addEmailTag; window.removeEmailTag = removeEmailTag;
window.flushEmailInput = flushEmailInput;
// ── Email Settings Page ─────────────────────────────────────────────────────
var _emailSettings = null;

async function loadEmailSettings() {
  try {
    var d = await apiGet('/pm/email-settings');
    _emailSettings = d;

    var locked = !d.allow_custom_sender;
    var lockedEl = document.getElementById('pm-email-settings-locked');
    var optionsEl = document.getElementById('pm-sender-options');
    if (lockedEl) lockedEl.style.display = locked ? 'block' : 'none';

    // Disable custom options if not allowed
    ['smtp','gmail'].forEach(function(v) {
      var radio = document.querySelector('input[name="pm-sender-type"][value="' + v + '"]');
      var label = document.getElementById('pm-sender-opt-' + v);
      if (radio) radio.disabled = locked;
      if (label) label.style.opacity = locked ? '.4' : '1';
      if (label) label.style.cursor  = locked ? 'not-allowed' : 'pointer';
    });

    // Set current selection
    var currentType = (d.smtp && d.smtp.sender_type) || 'eoh';
    var radio = document.querySelector('input[name="pm-sender-type"][value="' + currentType + '"]');
    if (radio) { radio.checked = true; updateSenderTypeUI(currentType); }

    // Fill SMTP fields
    if (d.smtp && d.smtp.sender_type !== 'eoh') {
      setField('user-smtp-host', d.smtp.smtp_host || '');
      setField('user-smtp-port', String(d.smtp.smtp_port || '465'));
      setField('user-smtp-user', d.smtp.smtp_user || '');
      setField('user-smtp-from-name', d.smtp.from_name || '');
      var passPh = document.getElementById('user-smtp-pass');
      if (passPh && d.smtp.has_pass) passPh.placeholder = '••••••••••••  (saved)';
      var verBadge = document.getElementById('user-smtp-verified-badge');
      if (verBadge) verBadge.style.display = d.smtp.is_verified ? 'inline' : 'none';
    }

    // Attach radio change listeners
    document.querySelectorAll('input[name="pm-sender-type"]').forEach(function(r) {
      r.addEventListener('change', function() { updateSenderTypeUI(r.value); });
    });

    // Show EOH sender info
    var eohInfo = document.getElementById('pm-eoh-sender-info');
    if (eohInfo) eohInfo.textContent = 'Emails sent via ERP Online Hub servers';
  } catch(e) { console.error('loadEmailSettings:', e.message); }
}

function updateSenderTypeUI(type) {
  var smtpConfig = document.getElementById('pm-smtp-config');
  if (smtpConfig) smtpConfig.style.display = (type === 'smtp' || type === 'gmail') ? 'block' : 'none';

  // Auto-fill host for Gmail
  if (type === 'gmail') {
    setField('user-smtp-host', 'smtp.gmail.com');
    setField('user-smtp-port', '587');
    var note = document.getElementById('gmail-setup-note');
    if (note) note.style.display = 'block';
  } else {
    var note = document.getElementById('gmail-setup-note');
    if (note) note.style.display = 'none';
    if (type === 'smtp' && !getField('user-smtp-host')) setField('user-smtp-host', 'smtp.zoho.com');
    if (type === 'smtp' && !getField('user-smtp-port')) setField('user-smtp-port', '465');
  }

  // Highlight selected radio label
  ['eoh','smtp','gmail'].forEach(function(v) {
    var label = document.getElementById('pm-sender-opt-' + v);
    if (label) label.style.borderColor = v === type ? 'var(--gl)' : 'var(--border)';
  });
}

async function saveUserEmailSettings() {
  var type = document.querySelector('input[name="pm-sender-type"]:checked');
  if (!type) return;
  var res_el = document.getElementById('user-email-settings-result');
  if (res_el) { res_el.style.color = 'var(--dim)'; res_el.textContent = 'Saving...'; }
  try {
    var body = { sender_type: type.value };
    if (type.value !== 'eoh') {
      body.smtp_host  = getField('user-smtp-host');
      body.smtp_port  = parseInt(getField('user-smtp-port')) || 465;
      body.smtp_user  = getField('user-smtp-user');
      body.smtp_pass  = getField('user-smtp-pass');
      body.from_name  = getField('user-smtp-from-name');
      if (!body.smtp_user) { if (res_el) { res_el.style.color='var(--red)'; res_el.textContent='Email/username is required'; } return; }
    }
    var d = await apiPut('/pm/email-settings', body);
    if (d.ok) {
      if (res_el) { res_el.style.color='var(--gl)'; res_el.textContent='✅ Saved!'; setTimeout(function(){ res_el.textContent=''; },3000); }
    } else {
      if (res_el) { res_el.style.color='var(--red)'; res_el.textContent=d.error||'Failed'; }
    }
  } catch(e) {
    if (res_el) { res_el.style.color='var(--red)'; res_el.textContent='Error: '+e.message; }
  }
}

async function testUserSmtp() {
  var res_el = document.getElementById('user-smtp-test-result');
  if (res_el) { res_el.style.color='var(--dim)'; res_el.textContent='Testing...'; }
  // Save first then test
  await saveUserEmailSettings();
  try {
    var d = await apiPost('/pm/email-settings/test', {});
    if (d.ok) {
      if (res_el) { res_el.style.color='var(--gl)'; res_el.textContent='✅ '+d.message; }
      var badge = document.getElementById('user-smtp-verified-badge');
      if (badge) badge.style.display = 'inline';
    } else {
      if (res_el) { res_el.style.color='var(--red)'; res_el.textContent='❌ '+(d.message||d.error||'Failed'); }
    }
  } catch(e) {
    if (res_el) { res_el.style.color='var(--red)'; res_el.textContent='Error: '+e.message; }
  }
}

window.loadEmailSettings      = loadEmailSettings;
window.saveUserEmailSettings  = saveUserEmailSettings;
window.testUserSmtp           = testUserSmtp;
window.updateSenderTypeUI     = updateSenderTypeUI;
function toggleExportDropdown() {
  var dd = document.getElementById('export-dropdown');
  if (!dd) return;
  dd.style.display = dd.style.display === 'none' ? 'block' : 'none';
  // Close on outside click
  setTimeout(function() {
    document.addEventListener('click', function closeDD(e) {
      var wrap = document.getElementById('export-dropdown-wrap');
      if (wrap && !wrap.contains(e.target)) {
        dd.style.display = 'none';
        document.removeEventListener('click', closeDD);
      }
    });
  }, 10);
}

async function exportProject(format) {
  var dd = document.getElementById('export-dropdown');
  if (dd) dd.style.display = 'none';
  if (!_project) { alert('No project selected'); return; }

  var res_el = document.getElementById('project-save-result');
  if (res_el) { res_el.style.color = 'var(--dim)'; res_el.textContent = '⏳ Generating ' + format.toUpperCase() + '...'; }

  try {
    var r = await fetch(API + '/pm/projects/' + _project.id + '/export', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + _token },
      body: JSON.stringify({ format: format })
    });
    if (!r.ok) {
      var err = await r.json().catch(function(){ return {}; });
      if (res_el) { res_el.style.color = 'var(--red)'; res_el.textContent = 'Export failed: ' + (err.error || r.status); }
      return;
    }
    var blob = await r.blob();
    var url  = URL.createObjectURL(blob);
    var a    = document.createElement('a');
    var ext  = { docx:'docx', pdf:'pdf', pptx:'pptx', xlsx:'xlsx' }[format] || format;
    a.href     = url;
    a.download = (_project.name || 'project').replace(/[^a-z0-9]/gi, '_') + '_Project.' + ext;
    document.body.appendChild(a); a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    if (res_el) { res_el.style.color = 'var(--gl)'; res_el.textContent = '✅ ' + format.toUpperCase() + ' downloaded!'; setTimeout(function(){ res_el.textContent=''; }, 4000); }
  } catch(e) {
    if (res_el) { res_el.style.color = 'var(--red)'; res_el.textContent = 'Export error: ' + e.message; }
  }
}

function toggleDocExportDropdown() {
  var dd = document.getElementById('doc-export-dropdown');
  if (!dd) return;
  dd.style.display = dd.style.display === 'none' ? 'block' : 'none';
  setTimeout(function() {
    document.addEventListener('click', function closeDD(e) {
      var wrap = document.getElementById('doc-export-wrap');
      if (wrap && !wrap.contains(e.target)) {
        dd.style.display = 'none';
        document.removeEventListener('click', closeDD);
      }
    });
  }, 10);
}

async function exportDoc(format, docId) {
  var dd = document.getElementById('doc-export-dropdown');
  if (dd) dd.style.display = 'none';
  var id = docId || _currentDocId;
  if (!_project || !id) { alert('No document selected'); return; }

  var status = document.getElementById('doc-export-status');
  var fmtLabel = { pdf:'PDF', docx:'Word', pptx:'PowerPoint', xlsx:'Excel' }[format] || format.toUpperCase();
  if (status) { status.style.color = 'var(--dim)'; status.textContent = '⏳ Generating ' + fmtLabel + '...'; }

  try {
    var r = await fetch(API + '/pm/projects/' + _project.id + '/documents/' + id + '/export', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + _token },
      body: JSON.stringify({ format: format })
    });

    if (!r.ok) {
      var err = await r.json().catch(function(){ return {}; });
      if (status) { status.style.color = 'var(--red)'; status.textContent = 'Export failed: ' + (err.error || r.status); }
      return;
    }

    var blob  = await r.blob();
    var url   = URL.createObjectURL(blob);
    var a     = document.createElement('a');
    var title = docId
      ? (document.getElementById('doc-viewer-title')?.textContent || 'document')
      : (document.getElementById('doc-viewer-title')?.textContent || 'document');
    var ext   = format;
    a.href     = url;
    a.download = title.replace(/[^a-z0-9]/gi, '_') + '.' + ext;
    document.body.appendChild(a); a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    if (status) { status.style.color = 'var(--gl)'; status.textContent = '✅ ' + fmtLabel + ' downloaded!'; setTimeout(function(){ status.textContent=''; }, 4000); }
  } catch(e) {
    if (status) { status.style.color = 'var(--red)'; status.textContent = 'Error: ' + e.message; }
  }
}

window.exportDoc                 = exportDoc;
window.toggleDocExportDropdown   = toggleDocExportDropdown;
